import React, { useState } from "react";
import { Col, Row, Tooltip } from "react-bootstrap";
import BankSlipInvoiceList from "./BankSlipInvoiceList";
import GetSvgIcon from "../../../images/svglist";
import { DownloadFile } from "../../Helper/FileStoreService";
import Toggler from "../../Utilities/Toggler";
import { NUMBER_NINE_DECIMAL } from "../../Helper/Constants";
import { initErrObj } from "./BankSlipMain";
import { numberInputOnWheelPreventChange } from "../../Helper/CommonMethods";

const INVALID_FORMAT = "Please check for input data format: xxxxxxxxx.xx";

const BankSlipDetailes = ({
  selectedBs,
  setSelectedBs,
  isAppovedClicked,
  invCols,
  invoiceList,
  payByCreditVal,
  isRemarkBlank,
  setIsRemarkBlank,
  errorObj,
  setErrorObj,
}) => {
  const onSuccess = (title, body) => {
    console.log("title", title, "body", body);
  };

  const onError = (errMsg) => {
    console.log("errMsg", errMsg);
  };

  const handelChangeData = (e) => {
    if (!!e) setIsRemarkBlank(false);
  };

  const initPymtAmt = {
    availableCN: 0,
    remainingCN: 0,
    usedCN: 0,
  };
  const requestCnAmount = parseFloat(selectedBs?.requestCnAmount) || 0;
  const requestAdvAmount = parseFloat(selectedBs?.requestAdvAmount) || 0;
  const [applyCreditNote, setApplyCreditNote] = useState(false);
  const [applyAdvPay, setApplyAdvPay] = useState(false);
  // const [inputInvoiceAmount, setInputInvoiceAmount] = useState(
  //   selectedBs?.totalInvoiceAmount
  // );
  // const [inputCnAmount, setInputCnAmount] = useState(selectedBs?.avlCnAmount);
  // const [finalAmount, setFinalAmount] = useState(
  //   selectedBs?.totalInvoiceAmount
  // );
  // const [cnLimit, setCnLimit] = useState(Object.assign({}, initPymtAmt));

  // Toggler handler for credit note
  const togglerHandler = (label, value) => {
    setApplyCreditNote(value);
    // let copySelBankSlip = Object.assign({}, selectedBs);
    const copySelBankSlip = { ...selectedBs };
    const reqAdv = parseFloat(copySelBankSlip.requestAdvAmount) || 0;
    const reqCn = value ? parseFloat(copySelBankSlip.requestCnAmount) || 0 : 0;
    const reqBnk = parseFloat(copySelBankSlip.requestBankSlipAmount) || 0;
    if (value) {
      // When credit note is applied
      const amt = selectedBs?.totalInvoiceAmount - selectedBs?.avlCnAmount;
      // copySelBankSlip.requestInvAmount = copySelBankSlip.totalInvoiceAmount;
      // copySelBankSlip.requestCnAmount = Math.min(
      //   copySelBankSlip.avlCnAmount,
      //   copySelBankSlip.requestInvAmount
      // );
      copySelBankSlip.remainingCN =
        copySelBankSlip.avlCnAmount - copySelBankSlip.requestCnAmount;
      // copySelBankSlip.finalAmount = amt > 0 ? amt.toFixed(2) : 0;

      copySelBankSlip.finalAmount = (reqAdv + reqCn + reqBnk).toFixed(2);
    } else {
      // copySelBankSlip.requestInvAmount = copySelBankSlip.totalInvoiceAmount;
      copySelBankSlip.requestCnAmount = 0;
      copySelBankSlip.remainingCN = 0;
      copySelBankSlip.finalAmount = reqAdv + reqBnk;
    }
    setSelectedBs(Object.assign({}, copySelBankSlip));
    // setErrorObj(JSON.parse(JSON.stringify(initErrObj)));
    setErrorObj((prev) => ({
      ...prev,
      cnAmt: { value: false, message: "" },
    }));
    // Custom error update logic
    // setErrorObj((prev) => {
    //   const copyErrObj = { ...prev };
    //   copyErrObj.cnAmt = { value: false, message: "" };

    //   const totalInvoice = selectedBs.totalInvoiceAmount || 0;
    //   const cnAmount = parseFloat(copySelBankSlip.requestCnAmount) || 0;
    //   const advAmount = parseFloat(copySelBankSlip.requestAdvAmount) || 0;

    //   if (cnAmount + advAmount > totalInvoice) {
    //     copyErrObj.cnAmt = {
    //       value: true,
    //       message:
    //         "Combined Credit Note and Advance Payment cannot exceed the Invoice amount.",
    //     };
    //   }

    //   return copyErrObj;
    // });
  };

  // Handle invoice amount change
  // const handleInvoiceAmountChange = (e) => {
  //   const invAmt = parseFloat(e.target.value) || 0;
  //   let copySelBankSlip = Object.assign({}, selectedBs);
  //   copySelBankSlip.requestInvAmount = invAmt;
  //   const newAmount = parseFloat(invAmt) || 0;

  //   if (applyCreditNote) {
  //     const finalAmt = requestCnAmount + requestAdvAmount;
  //     copySelBankSlip.finalAmount = finalAmt > 0 ? finalAmt?.toFixed(2) : 0;
  //   } else if (applyAdvPay) {
  //     const finalAmt = requestCnAmount + requestAdvAmount;
  //     copySelBankSlip.finalAmount = finalAmt > 0 ? finalAmt.toFixed(2) : 0;
  //   } else {
  //     copySelBankSlip.finalAmount = newAmount.toFixed(2);
  //   }
  //   setSelectedBs(Object.assign({}, copySelBankSlip));

  //   //==ERROR Handling
  //   let copyErrObj = Object.assign({}, errorObj);
  //   if (NUMBER_NINE_DECIMAL.test(invAmt)) {
  //     if (newAmount > selectedBs?.totalInvoiceAmount) {
  //       copyErrObj.invAmt.value = true;
  //       copyErrObj.invAmt.message =
  //         "Requested amount cannot be greater than Actual Invoice amount";
  //     } else {
  //       copyErrObj.invAmt.value = false;
  //       copyErrObj.invAmt.message = "";
  //     }
  //   } else {
  //     copyErrObj.invAmt.value = true;
  //     copyErrObj.invAmt.message = INVALID_FORMAT;
  //   }
  //   if (applyCreditNote) {
  //     if (copySelBankSlip.requestCnAmount > newAmount) {
  //       copyErrObj.cnAmt.value = true;
  //       copyErrObj.cnAmt.message =
  //         "Value cannot be greater than requested invoice amount";
  //     } else {
  //       copyErrObj.cnAmt.value = false;
  //       copyErrObj.cnAmt.message = "";
  //     }
  //   }

  //   setErrorObj(Object.assign({}, copyErrObj));
  // };
  const handleBankSlipAmountChange = (e) => {
    const bnkAmt = parseFloat(e.target.value);
    let copySelBankSlip = { ...selectedBs };
    copySelBankSlip.requestBankSlipAmount = bnkAmt;
    setSelectedBs(copySelBankSlip);

    const finalAmt = bnkAmt + requestCnAmount + requestAdvAmount;
    copySelBankSlip.finalAmount = finalAmt > 0 ? finalAmt.toFixed(2) : 0;
    // Optional: add validation if needed
    let copyErrObj = { ...errorObj };
    if (NUMBER_NINE_DECIMAL.test(e.target.value)) {
      copyErrObj.bnkAmt.value = false;
      copyErrObj.bnkAmt.message = "";
    } else {
      copyErrObj.bnkAmt.value = true;
      copyErrObj.bnkAmt.message =
        "Please check for input data format: xxxxxxxxx.xx";
    }
    if (bnkAmt < 1) {
      copyErrObj.bnkAmt.value = true;
      copyErrObj.bnkAmt.message = "Bank slip amount must be greater than 1 RM";
    } else {
      copyErrObj.bnkAmt.value = false;
      copyErrObj.bnkAmt.message = "";
    }
    // if (copySelBankSlip.requestInvAmount <= finalAmt) {
    //   copyErrObj.advAmt.value = false;
    //   copyErrObj.advAmt.message = "";
    //   copyErrObj.bnkAmt.value = false;
    //   copyErrObj.bnkAmt.message = "";
    //   copyErrObj.cnAmt.value = false;
    //   copyErrObj.cnAmt.message = "";
    // } else {
    //   copyErrObj.bnkAmt.value = true;
    //   copyErrObj.bnkAmt.message =
    //     "combined Amount Should not be less than invoice";
    // }
    // if (copySelBankSlip.requestInvAmount > finalAmt) {
    //   copyErrObj.advAmt.value = false;
    //   copyErrObj.advAmt.message = "";
    //   copyErrObj.bnkAmt.value = false;
    //   copyErrObj.bnkAmt.message = "";
    //   copyErrObj.cnAmt.value = false;
    //   copyErrObj.cnAmt.message = "";
    // } else {
    //   copyErrObj.bnkAmt.value = true;
    //   copyErrObj.bnkAmt.message =
    //     "Combined Amount Should not be more than invoice";
    // }
    // if (bnkAmt > copySelBankSlip.requestInvAmount) {
    //   copyErrObj.bnkAmt.value = true;
    //   copyErrObj.bnkAmt.message =
    //     "Bank slip amount should not be greater than invoice amount";
    // }
    // setErrorObj(copyErrObj);
  };

  // Toggler handler for advance payment
  const togglerHandlerForAdvPay = (label, value) => {
    setApplyAdvPay(value);
    // let copySelBankSlip = Object.assign({}, selectedBs);
    const copySelBankSlip = { ...selectedBs };
    const reqAdv = value
      ? parseFloat(copySelBankSlip.requestAdvAmount) || 0
      : 0;
    const reqInv = parseFloat(copySelBankSlip.requestInvAmount) || 0;
    const reqCn = parseFloat(copySelBankSlip.requestCnAmount) || 0;
    const reqBnk = parseFloat(copySelBankSlip.requestBankSlipAmount) || 0;
    if (value) {
      // When credit note is applied
      const amt = selectedBs?.totalInvoiceAmount - selectedBs?.avlAdvAmount;
      // copySelBankSlip.requestInvAmount = copySelBankSlip.totalInvoiceAmount;
      // copySelBankSlip.requestAdvAmount = Math.min(
      //   copySelBankSlip.avlAdvAmount,
      //   copySelBankSlip.requestInvAmount
      // );
      copySelBankSlip.requestAdvAmount = 0;
      copySelBankSlip.remainingAdv = copySelBankSlip.avlAdvAmount; // full available remaining
      // copySelBankSlip.finalAmount = copySelBankSlip.requestInvAmount;

      copySelBankSlip.finalAmount = (reqAdv + reqCn + reqBnk).toFixed(2);
    } else {
      // copySelBankSlip.requestInvAmount = copySelBankSlip.totalInvoiceAmount;
      copySelBankSlip.requestAdvAmount = 0;
      copySelBankSlip.remainingAdv = 0;
      copySelBankSlip.finalAmount = reqCn + reqBnk;
    }
    setSelectedBs(Object.assign({}, copySelBankSlip));
    // setErrorObj(JSON.parse(JSON.stringify(initErrObj)));
    setErrorObj((prev) => ({
      ...prev,
      advAmt: { value: false, message: "" },
    }));
    // Custom error update logic
    // setErrorObj((prev) => {
    //   const copyErrObj = { ...prev };
    //   copyErrObj.advAmt = { value: false, message: "" };

    //   const totalInvoice = selectedBs.totalInvoiceAmount || 0;
    //   const cnAmount = parseFloat(copySelBankSlip.requestCnAmount) || 0;
    //   const advAmount = parseFloat(copySelBankSlip.requestAdvAmount) || 0;

    //   if (cnAmount + advAmount > totalInvoice) {
    //     copyErrObj.cnAmt = {
    //       value: true,
    //       message:
    //         "Combined Credit Note and Advance Payment cannot exceed the Invoice amount.",
    //     };
    //   }

    //   return copyErrObj;
    // });
  };
  // Handle Advance payment change
  const handleCnAmountChange = (e) => {
    const newCnAmount = parseFloat(e.target.value);
    const avlCreditLimit = selectedBs?.avlCnAmount;
    let copySelBankSlip = Object.assign({}, selectedBs);

    // Ensure CN amount doesn't exceed available credit limit
    const validCnAmount = Math.min(newCnAmount, avlCreditLimit);
    // setInputCnAmount(validCnAmount);

    const requestAdvAmount = parseFloat(selectedBs?.requestAdvAmount) || 0;
    const reqBnk = parseFloat(copySelBankSlip.requestBankSlipAmount) || 0;
    if (applyCreditNote) {
      const amt = copySelBankSlip.requestInvAmount - newCnAmount;
      copySelBankSlip.requestCnAmount = newCnAmount;
      copySelBankSlip.remainingCN = avlCreditLimit - newCnAmount;
      const finalAmt = newCnAmount + requestAdvAmount + reqBnk;
      copySelBankSlip.finalAmount = finalAmt > 0 ? finalAmt.toFixed(2) : 0;

      // Update credit note limits
      setSelectedBs(Object.assign({}, copySelBankSlip));
    }

    //==ERROR Handling
    let copyErrObj = Object.assign({}, errorObj);
    if (NUMBER_NINE_DECIMAL.test(e.target.value)) {
      if (newCnAmount > avlCreditLimit) {
        copyErrObj.cnAmt.value = true;
        copyErrObj.cnAmt.message =
          "Value cannot be greater than available credit limit";
      } else if (newCnAmount < 0) {
        copyErrObj.cnAmt.value = true;
        copyErrObj.cnAmt.message = "Credit amount must be greater than 0 RM";
      }
      // else if (newCnAmount > selectedBs.requestInvAmount) {
      //   copyErrObj.cnAmt.value = true;
      //   copyErrObj.cnAmt.message =
      //     "Value cannot be greater than requested invoice amount";
      // } else if (
      //   validCnAmount + requestAdvAmount >
      //   selectedBs.totalInvoiceAmount
      // ) {
      //   copyErrObj.cnAmt.value = true;
      //   copyErrObj.cnAmt.message =
      //     "Combined Credit Note and Advance Payment cannot exceed the Invoice amount.";
      // }
      // // else if (
      // //   validCnAmount + reqBnk + requestAdvAmount <
      // //   selectedBs.requestInvAmount
      // // ) {
      // //   copyErrObj.cnAmt.value = true;
      // //   copyErrObj.cnAmt.message =
      // //     "Amount Should not be less than amount to be paid";
      // // }
      // else if (
      //   validCnAmount + requestAdvAmount + reqBnk >
      //   selectedBs.requestInvAmount
      // ) {
      //   copyErrObj.cnAmt.value = true;
      //   copyErrObj.cnAmt.message =
      //     "Combined Amount Should not be more than invoice";
      // }
      else {
        // copyErrObj.advAmt.value = false;
        // copyErrObj.advAmt.message = "";
        copyErrObj.cnAmt.value = false;
        copyErrObj.cnAmt.message = "";
        // copyErrObj.bnkAmt.value = false;
        // copyErrObj.bnkAmt.message = "";
      }
    } else {
      copyErrObj.cnAmt.value = true;
      copyErrObj.cnAmt.message = INVALID_FORMAT;
    }
    setErrorObj(Object.assign({}, copyErrObj));
  };
  const handleAdvAmountChange = (e) => {
    const newAdvAmount = parseFloat(e.target.value);
    let copySelBankSlip = Object.assign({}, selectedBs);
    const avlAdvLimit = selectedBs?.avlAdvAmount;
    const requestCnAmount = parseFloat(selectedBs?.requestCnAmount) || 0;
    const reqBnk = parseFloat(copySelBankSlip.requestBankSlipAmount) || 0;
    // Ensure Advance amount doesn't exceed available Advance limit
    const validAdvAmount = Math.min(newAdvAmount, avlAdvLimit);
    // setInputAdvAmount(validAdvAmount);

    if (applyAdvPay) {
      const amt = copySelBankSlip.requestInvAmount - newAdvAmount;
      copySelBankSlip.requestAdvAmount = newAdvAmount;
      copySelBankSlip.remainingAdv = avlAdvLimit - newAdvAmount;
      const finalAmt = requestCnAmount + newAdvAmount + reqBnk;
      copySelBankSlip.finalAmount = finalAmt > 0 ? finalAmt.toFixed(2) : 0;

      // Update Advance payment limits
      setSelectedBs(Object.assign({}, copySelBankSlip));
    }

    //==ERROR Handling
    let copyErrObj = Object.assign({}, errorObj);
    if (NUMBER_NINE_DECIMAL.test(e.target.value)) {
      if (newAdvAmount > avlAdvLimit) {
        copyErrObj.advAmt.value = true;
        copyErrObj.advAmt.message =
          "Value cannot be greater than available credit limit";
      } else if (newAdvAmount < 0) {
        copyErrObj.advAmt.value = true;
        copyErrObj.advAmt.message = "Advance amount must be greater than 0 RM";
      }
      // else if (newAdvAmount > selectedBs.requestInvAmount) {
      //   copyErrObj.advAmt.value = true;
      //   copyErrObj.advAmt.message =
      //     "Value cannot be greater than requested invoice amount";
      // } else if (
      //   validAdvAmount + requestCnAmount >
      //   selectedBs.totalInvoiceAmount
      // ) {
      //   copyErrObj.advAmt.value = true;
      //   copyErrObj.advAmt.message =
      //     "Combined Credit Note and Advance Payment cannot exceed the Invoice amount.";
      // }
      // // else if (
      // //   validAdvAmount + reqBnk + requestCnAmount <
      // //   selectedBs.requestInvAmount
      // // ) {
      // //   copyErrObj.advAmt.value = true;
      // //   copyErrObj.advAmt.message =
      // //     "Amount Should not be less than amount to be paid";
      // // }
      // else if (
      //   validAdvAmount + requestCnAmount + reqBnk >
      //   selectedBs.requestInvAmount
      // ) {
      //   copyErrObj.advAmt.value = true;
      //   copyErrObj.advAmt.message =
      //     "Combined Amount Should not be more than invoice";
      // }
      else {
        copyErrObj.advAmt.value = false;
        copyErrObj.advAmt.message = "";
        // copyErrObj.cnAmt.value = false;
        // copyErrObj.cnAmt.message = "";
        // copyErrObj.bnkAmt.value = false;
        // copyErrObj.bnkAmt.message = "";
      }
    } else {
      copyErrObj.advAmt.value = true;
      copyErrObj.advAmt.message = INVALID_FORMAT;
    }
    setErrorObj(Object.assign({}, copyErrObj));
  };

  return (
    <div>
      <Row>
        <Row>
          <Col sm={2} className="text-start">
            <label className="form-label fs-6 theme-label">Customer :</label>
          </Col>
          <Col sm={4} className="overflow-auto">
            {selectedBs?.custName}
          </Col>
          <Col sm={2} className="text-end">
            <label className="form-label fs-6 theme-label">Bank Slip :</label>
          </Col>
          <Col sm={3} className="overflow-hidden">
            <span className="p-2 Form-Lable-link">{selectedBs?.bank_slip}</span>
          </Col>
          <Col sm={1} className="text-end">
            <>
              <div
                data-tooltip-id={"bs"}
                className="me-3"
                onClick={() =>
                  DownloadFile(selectedBs?.bank_slip, onSuccess, onError)
                }
              >
                {" "}
                {GetSvgIcon("IconFiledownload")}
              </div>
              <Tooltip id={"bs"} content="Download Invoice" place="left" />
            </>
          </Col>
        </Row>

        <Row className="p-1">
          <Col sm={3} className="text-start mt-2">
            <label className="form-label fs-6 theme-label ms-2">
              Remarks :
            </label>
          </Col>
          <Col>
            <textarea
              className="form-control grd-bg p-2 p my-2 rounded-3 mt-1"
              id="bs-remark"
              rows={1}
              disabled
            >
              {selectedBs?.remarks}
            </textarea>
          </Col>
        </Row>
        <Row>
          {/* <BankSlipInvoiceList invColumns={invCols} invList={invoiceList} /> */}
          <Col sm={3} className="text-start mt-2">
            <label className="form-label fs-6 theme-label">Invoices :</label>
          </Col>
          <Col
            // sm={9}
            className="overflow-auto text-start grd-bg p-2 p my-2 rounded-3 mt-1 mx-1"
          >
            {selectedBs?.statusId === 810
              ? selectedBs?.invoice_ids
              : selectedBs?.approved_invoice_ids}
          </Col>
        </Row>
        {selectedBs?.statusId === 811 && (
          <>
            <div className="p-2">
              <div className="d-flex justify-content-between align-item-center">
                <div className="col grd-bg p-2 p my-2 rounded-3">
                  <div className="fw-bold">Credit Note Utilized</div>
                  <div className="theme-blue-txt">{selectedBs?.cn_utl_amt}</div>
                </div>
                <div className="col grd-bg p-2 p my-2 rounded-3">
                  <div className="fw-bold">Advance Payment Utilized</div>
                  <div className="theme-blue-txt">
                    {selectedBs?.adv_utl_amt}
                  </div>
                </div>
                <div className="col grd-bg p-2 p my-2 rounded-3">
                  <div className="fw-bold">Manual Pay</div>
                  <div className="theme-blue-txt">{selectedBs?.manual_amt}</div>
                </div>
                <div className="col grd-bg p-2 p my-2 rounded-3">
                  <div className="fw-bold">Bank Slip Amount</div>
                  <div className="theme-blue-txt">
                    {selectedBs?.bank_slip_amt}
                  </div>
                </div>
              </div>
            </div>
          </>
        )}

        {/* {isAppovedClicked && ( */}
        <>
          {/* <Row className="mt-2"></Row>className=" border border-2 border-info" */}
          {selectedBs?.statusId === 810 && (
            <div>
              {/* <Row>
                <Col className="fs-4">CONFIRM PAYMENT</Col>
              </Row> */}
              <div className="row mt-2">
                <div className="col-md-3  text-start">
                  <label
                    htmlFor="floatingInputGrid"
                    className="form-label theme-label"
                  >
                    Invoice Amount :
                  </label>
                </div>

                <div className="col-md-7 mb-1 text-start">
                  <label className="form-label ">
                    <b>{selectedBs?.totalInvoiceAmount?.toFixed(2)} RM</b>
                  </label>
                  <div className="col-md-2"></div>
                </div>
                <div className="row">
                  <div className="col-md-3 text-start">
                    <label
                      htmlFor="floatingInputGrid"
                      className="form-label theme-label"
                    >
                      Bank Slip Amount :
                    </label>
                  </div>
                  {/* <div className="col-md-8 mb-2 text-start ">
                      <label className="form-label">
                        <b>{(+selectedBs?.finalAmount).toFixed(2)} RM</b>
                      </label>
                    </div> */}

                  <div className="col-md-7 mb-1 text-start pe-0">
                    <input
                      className="form-control"
                      type="number"
                      inputMode="numeric"
                      maxLength={12}
                      value={selectedBs?.requestBankSlipAmount}
                      onChange={handleBankSlipAmountChange}
                      onWheel={(e) => numberInputOnWheelPreventChange(e)}
                      // disabled={true}
                    />
                    {!!errorObj?.bnkAmt?.value && errorObj?.bnkAmt?.value && (
                      <div>
                        <span className="text-danger fw-bold font-12">
                          &#9888; {errorObj?.bnkAmt?.message}
                        </span>
                      </div>
                    )}
                  </div>
                </div>
                {/* <div className="row">
                  <div className="col-md-3  text-start pe-0">
                    <label
                      htmlFor="floatingInputGrid"
                      className="form-label theme-label mt-2"
                    >
                      Amount To Be Paid :
                      <span className="text-danger">&#9733;</span>
                    </label>
                  </div>
                  <div className="col-md-7 mb-1 text-start pe-0">
                    <input
                      className="form-control"
                      type="text"
                      inputMode="numeric"
                      maxLength={12}
                      value={selectedBs?.requestInvAmount}
                      onChange={handleInvoiceAmountChange}
                      // disabled={true}
                    />
                    {!!errorObj?.invAmt?.value && errorObj?.invAmt?.value && (
                      <div>
                        <span className="text-danger fw-bold font-12">
                          &#9888; {errorObj?.invAmt?.message}
                        </span>
                      </div>
                    )}
                  </div>
                  <div className="col-md-2"></div>
                </div> */}
                <div className="col-md-2"></div>
              </div>
              {/* Card Details */}
              <Row className="mt-2">
                <Col
                  md={selectedBs?.avlAdvAmount > 0 ? 6 : 12}
                  className="px-2"
                >
                  {selectedBs?.avlCnAmount > 0 && (
                    <div class="card text-bg-light mb-3">
                      <div class="card-header">
                        <div className="row ">
                          {/* <div className="col-md-6 text-start "></div> */}
                          <div className="col-md-12 mb-2 text-start d-flex align-items-center">
                            <Toggler
                              btnName="btn_from"
                              isBtn1Checked={applyCreditNote === true}
                              isBtn2Checked={applyCreditNote === false}
                              btn1Value={true}
                              btn2Value={false}
                              btn1Label="YES"
                              btn2Label="NO"
                              handler={togglerHandler}
                            />
                            <span className="ms-2">Apply Credit Amount</span>
                          </div>
                        </div>
                      </div>
                      <div class="card-body">
                        {selectedBs?.avlCnAmount > 0 && (
                          <>
                            <div className="row">
                              <div className="col-md-12 text-start">
                                <label
                                  htmlFor="floatingInputGrid"
                                  className="form-label theme-label"
                                >
                                  Available Credit Amount :
                                </label>
                              </div>
                              <div className="col-md-6 mb-1 text-start">
                                <label className="form-label">
                                  <b>
                                    {selectedBs?.avlCnAmount?.toFixed(2)} RM
                                  </b>
                                </label>
                              </div>
                              <div className="col-md-2"></div>
                            </div>
                            {applyCreditNote && (
                              <div className="row">
                                <div className="col-md-12 text-start">
                                  <label
                                    htmlFor="floatingInputGrid"
                                    className="form-label theme-label"
                                  >
                                    Remaining Credit Amount :
                                  </label>
                                </div>
                                <div className="col-md-6 mb-1 text-start">
                                  <label className="form-label">
                                    <b>
                                      {selectedBs?.remainingCN?.toFixed(2)} RM
                                    </b>
                                  </label>
                                </div>
                                <div className="col-md-2"></div>
                              </div>
                            )}

                            {applyCreditNote && (
                              <div className="row">
                                <div className="col-md-12 mt-1 text-start pe-0">
                                  <label
                                    htmlFor="floatingInputGrid"
                                    className="form-label theme-label"
                                  >
                                    Enter CN amount to adjust invoice:
                                  </label>
                                </div>
                                <div className="col-md text-start ">
                                  <input
                                    className="form-control"
                                    type="number"
                                    value={selectedBs?.requestCnAmount}
                                    onChange={handleCnAmountChange}
                                    onWheel={(e) =>
                                      numberInputOnWheelPreventChange(e)
                                    }
                                  />
                                  {!!errorObj?.cnAmt?.value &&
                                    errorObj?.cnAmt?.value && (
                                      <div>
                                        <span className="text-danger fw-bold font-12">
                                          &#9888; {errorObj?.cnAmt?.message}
                                        </span>
                                      </div>
                                    )}
                                </div>
                                <div className="col-md-2"></div>
                              </div>
                            )}
                          </>
                        )}
                      </div>
                    </div>
                  )}
                </Col>
                {selectedBs?.avlAdvAmount > 0 && (
                  <Col
                    md={selectedBs?.avlCnAmount > 0 ? 6 : 12}
                    className="px-2"
                  >
                    <div class="card text-bg-light mb-3">
                      <div class="card-header">
                        <div className="row ">
                          {/* <div className="col-md-6 text-start "></div> */}
                          <div className="col-md-12 mb-2 text-start d-flex align-items-center">
                            <Toggler
                              btnName="btn_from1"
                              isBtn1Checked={applyAdvPay === true}
                              isBtn2Checked={applyAdvPay === false}
                              btn1Value={true}
                              btn2Value={false}
                              btn1Label="YES"
                              btn2Label="NO"
                              handler={togglerHandlerForAdvPay}
                            />
                            <span className="ms-2">Apply Advance Payment</span>
                          </div>
                        </div>
                      </div>
                      <div class="card-body">
                        {selectedBs?.avlAdvAmount > 0 && (
                          <>
                            <div className="row">
                              <div className="col-md-12 text-start">
                                <label
                                  htmlFor="floatingInputGrid"
                                  className="form-label theme-label"
                                >
                                  Available Advance payment:
                                </label>
                              </div>
                              <div className="col-md-6 mb-1 text-start">
                                <label className="form-label">
                                  <b>
                                    {selectedBs?.avlAdvAmount?.toFixed(2)} RM
                                  </b>
                                </label>
                              </div>
                              <div className="col-md-2"></div>
                            </div>
                            {applyAdvPay && (
                              <div className="row">
                                <div className="col-md-12 text-start">
                                  <label
                                    htmlFor="floatingInputGrid"
                                    className="form-label theme-label"
                                  >
                                    Remaining Advance Payment:
                                  </label>
                                </div>
                                <div className="col-md-6 mb-1 text-start">
                                  <label className="form-label">
                                    <b>
                                      {selectedBs?.remainingAdv?.toFixed(2)} RM
                                    </b>
                                  </label>
                                </div>
                                <div className="col-md-2"></div>
                              </div>
                            )}

                            {applyAdvPay && (
                              <div className="row">
                                <div className="col-md-12 mt-1 text-start pe-0">
                                  <label
                                    htmlFor="floatingInputGrid"
                                    className="form-label theme-label"
                                  >
                                    Enter Advance amount to adjust invoice:
                                  </label>
                                </div>
                                <div className="col-md text-start">
                                  <input
                                    className="form-control"
                                    type="number"
                                    value={selectedBs?.requestAdvAmount}
                                    onChange={handleAdvAmountChange}
                                    onWheel={(e) =>
                                      numberInputOnWheelPreventChange(e)
                                    }
                                  />
                                  {!!errorObj?.advAmt?.value &&
                                    errorObj?.advAmt?.value && (
                                      <div>
                                        <span className="text-danger fw-bold font-12">
                                          &#9888; {errorObj?.advAmt?.message}
                                        </span>
                                      </div>
                                    )}
                                </div>
                                <div className="col-md-2"></div>
                              </div>
                            )}
                          </>
                        )}
                      </div>
                    </div>
                  </Col>
                )}
              </Row>
              <hr></hr>

              <Row className="mt-2">
                <div className="col-md-3 text-start pe-0">
                  <label
                    htmlFor="floatingInputGrid"
                    className="form-label theme-label "
                  >
                    Final Amount:
                  </label>
                </div>
                <div className="col-md-8 mb-2 text-start ">
                  <label className="form-label">
                    <b>{(+selectedBs?.finalAmount).toFixed(2)} RM</b>
                  </label>
                </div>
              </Row>
              <div className="row">
                <div className="col-md-3 text-start pe-0">
                  <label
                    htmlFor="floatingInputGrid"
                    className="form-label theme-label "
                  >
                    Payment Remark <span className="text-danger">&#9733;</span>
                  </label>
                </div>
                <div className="col-md-8 mb-2 text-start">
                  <textarea
                    className="form-control"
                    id="pay-remark"
                    rows={2}
                    onChange={(e) => handelChangeData(e.target.value)}
                  ></textarea>

                  {isRemarkBlank && (
                    <div style={{ textAlign: "left" }}>
                      <span className="badge bg-danger">
                        &#9888; This field is required.
                      </span>
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}
        </>
        {/* )} */}
      </Row>
    </div>
  );
};

export default BankSlipDetailes;
